// extracted by mini-css-extract-plugin
module.exports = {"container":"StrmrmfsSearch_container__1q04Z","input":"StrmrmfsSearch_input__zU-zz"};